import { ProductMedias, ProductMedia } from '../../../../types/interfaces';

import {
  AlreadyTransformedMediasTransformer,
  CloudinaryMediaTransformer,
  UrlFetchCloudinaryTransformer,
} from './MediasTransformer';

export class TransformerFactory {
  static getTransformer(productMedias: ProductMedias) {
    if (
      productMedias.common.some(this.isOldFormat) ||
      productMedias.combinationMedias.some((combinationMedia) =>
        combinationMedia.medias.some(this.isOldFormat)
      )
    ) {
      return new AlreadyTransformedMediasTransformer();
    }

    if (productMedias)
      if (TransformerFactory.areMediasInCloudinary(productMedias)) {
        return new CloudinaryMediaTransformer();
      }
    return new UrlFetchCloudinaryTransformer();
  }

  private static areMediasInCloudinary(catalogMedias: ProductMedias) {
    return (
      catalogMedias.common.some(TransformerFactory.isInCloudinary) ||
      catalogMedias.combinationMedias.some((combinationMedia) =>
        combinationMedia.medias.some(TransformerFactory.isInCloudinary)
      )
    );
  }

  private static isInCloudinary(media: ProductMedia) {
    return media.video || media.image?.url.includes('t_pdpHeroGallery');
  }

  private static isOldFormat(media: ProductMedia) {
    return (
      media.image &&
      !media.image.url &&
      Object.prototype.hasOwnProperty.call(media.image, 'thumbnail')
    );
  }
}
